export default {
  /**
   *  @type {string} 検索画面
   */
  search: '/admin/staff/',
  /**
   * 参照画面
   * @param {string} id 社員ID
   */
  refer: (id) => {
    return `/admin/staff/refer/${id}`;
  },
  /**
   * @type {string} 新規作成画面
   */
  newEdit: '/admin/staff/edit/',
  /**
   * 編集画面
   * @param {string} id 社員ID
   */
  edit: (id) => {
    return `/admin/staff/edit/${id}`;
  },
  /**
   * @type {string} 一括登録画面
   */
  bulkUpdate: '/admin/staff/bulk-update',
};
